import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostUpdateVisible = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_UPDATE_VISIBLE_JACKPOT
            });
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostUpdateVisible as SetPostUpdateVisible
}